import { lazy } from "react";
import Loadable from "app/components/Loadable";

const LoanMaster = Loadable(lazy(() => import("./LoanMaster")));

const loanmasternewRoute = [

    { path: "/loan-master", element: <LoanMaster /> },
    { path: "/loan-master/:loanId", element: <LoanMaster /> },


];
export default loanmasternewRoute;
